'use client';

import { cn } from '@ahm/common-helpers';

type Tab = 'menu' | 'overview';

interface TabNavigationProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  return (
    <div className="flex gap-8 border-b border-white/10 mb-6 w-full justify-between items-center">
      <button
        onClick={() => onTabChange('menu')}
        className={cn(
          'pb-3 text-sm font-medium transition-colors relative w-full',
          activeTab === 'menu' ? 'text-white' : 'text-white/40'
        )}
      >
        THỰC ĐƠN
        {activeTab === 'menu' && (
          <div className="absolute bottom-0 inset-x-0 h-0.5 bg-primary" />
        )}
      </button>

      <button
        onClick={() => onTabChange('overview')}
        className={cn(
          'pb-3 text-sm font-medium transition-colors relative w-full',
          activeTab === 'overview' ? 'text-white' : 'text-white/40'
        )}
      >
        TỔNG QUAN
        {activeTab === 'overview' && (
          <div className="absolute bottom-0 inset-x-0 h-0.5 bg-primary" />
        )}
      </button>
    </div>
  );
}
